/**
 * Foto e video delle stagioni.
 *
 * Stanno nel frontend e non nel registro `SEASONS` del backend perche' il
 * deploy sulla VM ricostruisce solo il frontend: un asset nuovo non deve
 * richiedere il riavvio dell'API. Ogni sezione della pagina stagione si rende
 * solo se qui c'e' il suo media: «primavera», che condivide il template,
 * resta col layout di sempre.
 *
 * Gli scatti sono reali (archivio NAUSICAA). Solo il loop di chiusura e'
 * generato con AI e dichiarato (EXIF + ASSETS A-15).
 * `src: null` su un video = poster fermo con Ken Burns.
 */
const N = '/assets/stagioni/natale';

const MEDIA = {
  natale: {
    hero: {
      src: null,
      srcMobile: null,
      poster: `${N}/hero-poster.jpg`,
      width: 1920,
      height: 1080,
      alt: {
        it: 'Tavola delle feste: posate dorate su runner rosso, piatti color sabbia su sottopiatto dorato e foglie dorate',
        en: 'Holiday table: gold cutlery on a red runner, sand-coloured plates on a gold charger and gold leaves',
      },
    },
    home: {
      src: `${N}/home.webp`,
      alt: {
        it: 'Piatti color sabbia su sottopiatto dorato e posate oro su runner rosso, tra pigne e bacche dorate',
        en: 'Sand-coloured plates on a gold charger and gold cutlery on a red runner, among pine cones and gold berries',
      },
    },
    storie: {
      src: `${N}/storie.webp`,
      alt: {
        it: 'Piatti color sabbia su sottopiatto dorato e posate oro su runner rosso, tra pigne e bacche dorate',
        en: 'Sand-coloured plates on a gold charger and gold cutlery on a red runner, among pine cones and gold berries',
      },
    },
    ideas: [
      {
        src: `${N}/idea-1.webp`,
        alt: {
          it: 'Posate dorate su sottopiatto glitterato e piatti decorati con agrifoglio',
          en: 'Gold cutlery on a glitter charger with holly-patterned plates',
        },
      },
      {
        src: `${N}/idea-2.webp`,
        alt: {
          it: 'Portacandela in vetro con fiocco rosso, calici di vino rosso e pigne color marsala',
          en: 'Glass candle holder with a red bow, glasses of red wine and marsala pine cones',
        },
      },
      {
        src: `${N}/idea-3.webp`,
        // Scatto reale: NAUSICAA, «Mare blu» _DSC7426 (ASSETS A-15).
        alt: {
          it: 'Tovagliolo blu notte su un piatto turchese, sopra un sottopiatto in rafia azzurra',
          en: 'Midnight-blue napkin on a turquoise plate, over a light-blue raffia charger',
        },
      },
    ],
    gallery: [
      {
        src: `${N}/gallery-1.webp`,
        ratio: '3/4',
        alt: {
          it: 'Tazze e piatti a quadri rossi e verdi con motivo a fiocco',
          en: 'Red and green check cups and plates with a bow pattern',
        },
      },
      {
        src: `${N}/gallery-2.webp`,
        ratio: '1/1',
        alt: { it: 'Pigne color marsala e calici rossi', en: 'Marsala pine cones and red glasses' },
      },
      {
        src: `${N}/gallery-3.webp`,
        ratio: '1/1',
        alt: {
          it: 'Tovagliolo a quadri con fiocco rosso su sottopiatto dorato',
          en: 'Check napkin with a red bow on a gold charger',
        },
      },
      {
        src: `${N}/gallery-4.webp`,
        ratio: '3/4',
        alt: {
          it: 'Tessili con agrifoglio e quadri, con una fascia rossa',
          en: 'Holly and check textiles with a red band',
        },
      },
      {
        src: `${N}/gallery-5.webp`,
        ratio: '3/4',
        alt: {
          it: 'Cucchiaio di legno legato con un nastro rosso su un canovaccio a quadri',
          en: 'Wooden spoon tied with a red ribbon on a check tea towel',
        },
      },
      {
        src: `${N}/gallery-6.webp`,
        ratio: '3/4',
        alt: {
          it: 'Tazze bianche a righe nere con manici dorati',
          en: 'White mugs with black stripes and gold handles',
        },
      },
    ],
    closing: {
      src: `${N}/closing.mp4`,
      srcMobile: `${N}/closing-720.mp4`,
      poster: `${N}/closing-poster.jpg`,
      width: 1920,
      height: 1080,
    },
  },
};

export const seasonMedia = (slug) => MEDIA[slug] || null;

export const altOf = (item, lang) => item?.alt?.[lang] || item?.alt?.it || '';
